var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 669,
    height: 358,
    viewBox: "0 0 669 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.876 251.984C541.171 252.132 526.411 242.538 514.161 229.18C511.799 226.523 509.511 222.981 507.445 218.996C496.891 199.07 494.087 175.97 498.884 153.904C506.781 117.742 524.05 52.9458 554.086 5.56617C557.26 0.547768 564.566 0.547768 567.739 5.56617C597.702 52.9458 614.971 117.742 622.942 153.904C627.739 175.897 624.861 199.07 614.381 218.996C612.315 222.907 610.027 226.45 607.665 229.18C595.341 242.538 580.581 252.132 560.876 251.984Z",
    fill: "#FF6550"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M622.056 153.904C614.16 117.742 596.89 52.9458 566.854 5.56615C564.492 1.87615 559.843 0.916763 556.3 2.76176C559.105 5.04956 561.466 8.00156 563.238 11.6178C586.189 58.407 600.138 111.986 607.222 144.384C612.462 168.221 609.363 193.166 598.071 214.789C595.71 219.291 593.2 223.35 590.47 226.45C578.957 238.996 565.378 248.59 548.109 250.877C551.872 251.689 555.784 252.058 559.99 252.058C579.695 252.206 594.455 242.612 606.706 229.254C609.067 226.597 611.355 223.055 613.422 219.07C624.049 199.07 626.927 175.97 622.056 153.904Z",
    fill: "#FF7364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M560.876 251.984C541.171 252.132 526.411 242.538 514.161 229.18C511.799 226.523 509.511 222.981 507.445 218.996C496.891 199.07 494.087 175.97 498.884 153.904C506.781 117.742 524.05 52.9458 554.086 5.56617C557.26 0.547768 564.566 0.547768 567.739 5.56617C597.702 52.9458 614.971 117.742 622.942 153.904C627.739 175.897 624.861 199.07 614.381 218.996C612.315 222.907 610.027 226.45 607.665 229.18C595.341 242.538 580.581 252.132 560.876 251.984Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M560.876 210.066L591.872 187.705",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M560.876 179.07L533.201 157.668",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M492.168 272.648H445.01C431.136 272.648 419.844 261.357 419.844 247.483V158.923C419.844 145.048 431.136 133.757 445.01 133.757H492.094C505.969 133.757 517.26 145.048 517.26 158.923V247.483C517.334 261.357 506.043 272.648 492.168 272.648Z",
    fill: "#E97E1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M491.43 133.757H480.36C494.235 133.757 505.526 145.048 505.526 158.923V247.483C505.526 261.357 494.235 272.648 480.36 272.648H491.43C505.305 272.648 516.596 261.357 516.596 247.483V158.923C516.596 144.974 505.305 133.757 491.43 133.757Z",
    fill: "#E8531F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M492.168 272.648H445.01C431.136 272.648 419.844 261.357 419.844 247.483V158.923C419.844 145.048 431.136 133.757 445.01 133.757H492.094C505.969 133.757 517.26 145.048 517.26 158.923V247.483C517.334 261.357 506.043 272.648 492.168 272.648Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M468.626 251.984L489.29 232.944",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M468.626 220.398L445.748 210.066",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M560.876 334.788V126.672",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M468.626 187.926V334.788",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.592 252.722C143.048 252.722 162.873 199.856 162.873 134.642C162.873 69.4283 143.048 16.5624 118.592 16.5624C94.1374 16.5624 74.3125 69.4283 74.3125 134.642C74.3125 199.856 94.1374 252.722 118.592 252.722Z",
    fill: "#FFB845"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M118.592 16.5624C118.223 16.5624 117.854 16.5624 117.412 16.6362C137.854 27.1158 153.278 75.012 153.278 132.576C153.278 196.782 134.09 248.959 110.179 250.582C112.91 251.984 115.714 252.722 118.592 252.722C143.02 252.722 162.872 199.882 162.872 134.642C162.872 69.4032 143.02 16.5624 118.592 16.5624Z",
    fill: "#D89535"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.592 252.722C143.048 252.722 162.873 199.856 162.873 134.642C162.873 69.4283 143.048 16.5624 118.592 16.5624C94.1374 16.5624 74.3125 69.4283 74.3125 134.642C74.3125 199.856 94.1374 252.722 118.592 252.722Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.371 95.676V326.67",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.593 168L136.083 145.122",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.593 213.018L99.6997 193.313",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.371 134.273L103.095 117.078",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M140.733 121.432C144.116 121.432 146.858 118.69 146.858 115.307C146.858 111.924 144.116 109.181 140.733 109.181C137.35 109.181 134.607 111.924 134.607 115.307C134.607 118.69 137.35 121.432 140.733 121.432Z",
    fill: "#EF8C3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7 90.7314C101.86 90.7314 103.611 88.9801 103.611 86.82C103.611 84.6598 101.86 82.9086 99.7 82.9086C97.5399 82.9086 95.7886 84.6598 95.7886 86.82C95.7886 88.9801 97.5399 90.7314 99.7 90.7314Z",
    fill: "#FFD766"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.161 81.7278C126.995 81.7278 128.482 80.2407 128.482 78.4068C128.482 76.5721 126.995 75.0858 125.161 75.0858C123.327 75.0858 121.84 76.5721 121.84 78.4068C121.84 80.2407 123.327 81.7278 125.161 81.7278Z",
    fill: "#FFD766"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M447.076 171.616C451.234 171.616 454.604 168.246 454.604 164.089C454.604 159.931 451.234 156.561 447.076 156.561C442.919 156.561 439.549 159.931 439.549 164.089C439.549 168.246 442.919 171.616 447.076 171.616Z",
    fill: "#FFB845"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M470.692 173.83C473.668 173.83 476.08 171.418 476.08 168.443C476.08 165.467 473.668 163.055 470.692 163.055C467.717 163.055 465.305 165.467 465.305 168.443C465.305 171.418 467.717 173.83 470.692 173.83Z",
    fill: "#FFB845"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M447.076 240.914C450.052 240.914 452.464 238.503 452.464 235.527C452.464 232.552 450.052 230.14 447.076 230.14C444.101 230.14 441.689 232.552 441.689 235.527C441.689 238.503 444.101 240.914 447.076 240.914Z",
    fill: "#E8531F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M486.707 196.93C489.193 196.93 491.209 194.914 491.209 192.428C491.209 189.941 489.193 187.926 486.707 187.926C484.221 187.926 482.205 189.941 482.205 192.428C482.205 194.914 484.221 196.93 486.707 196.93Z",
    fill: "#E8531F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M95.1982 162.686C98.5811 162.686 101.324 159.944 101.324 156.561C101.324 153.178 98.5811 150.436 95.1982 150.436C91.8152 150.436 89.0728 153.178 89.0728 156.561C89.0728 159.944 91.8152 162.686 95.1982 162.686Z",
    fill: "#EF8C3A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.998 71.0268C112.381 71.0268 115.124 68.2844 115.124 64.9014C115.124 61.5184 112.381 58.776 108.998 58.776C105.615 58.776 102.873 61.5184 102.873 64.9014C102.873 68.2844 105.615 71.0268 108.998 71.0268Z",
    fill: "#EF8C3A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M136.305 193.535C139.688 193.535 142.43 190.792 142.43 187.409C142.43 184.026 139.688 181.284 136.305 181.284C132.922 181.284 130.179 184.026 130.179 187.409C130.179 190.792 132.922 193.535 136.305 193.535Z",
    fill: "#EF8C3A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M158.149 78.333C167.605 78.333 175.271 70.6674 175.271 61.2114C175.271 51.7554 167.605 44.0898 158.149 44.0898C148.693 44.0898 141.028 51.7554 141.028 61.2114C141.028 70.6674 148.693 78.333 158.149 78.333Z",
    fill: "#FF9F48"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M158.149 44.0898C158.002 44.0898 157.928 44.0898 157.78 44.0898C162.725 47.1156 166.046 52.5768 166.046 58.776C166.046 68.0748 158.592 75.6763 149.293 75.8976C151.876 77.4474 154.902 78.333 158.149 78.333C167.596 78.333 175.271 70.6578 175.271 61.2114C175.271 51.765 167.596 44.0898 158.149 44.0898Z",
    fill: "#EF8C3A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M158.149 78.333C167.605 78.333 175.271 70.6674 175.271 61.2114C175.271 51.7554 167.605 44.0898 158.149 44.0898C148.693 44.0898 141.028 51.7554 141.028 61.2114C141.028 70.6674 148.693 78.333 158.149 78.333Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M443.903 334.788C443.903 315.452 459.549 299.881 478.81 299.881C498.072 299.881 513.718 315.452 513.718 334.788H443.903Z",
    fill: "#FF6550"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M478.811 299.881C475.194 299.881 471.8 300.397 468.479 301.43C482.722 305.785 493.054 319.069 493.054 334.788H513.644C513.718 315.452 498.072 299.881 478.811 299.881Z",
    fill: "#FF7364"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M443.903 334.788C443.903 315.452 459.549 299.881 478.81 299.881C498.072 299.881 513.718 315.452 513.718 334.788H443.903Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M496.596 334.788C496.596 321.947 506.928 311.689 519.696 311.689C532.463 311.689 542.795 322.021 542.795 334.788H496.596Z",
    fill: "#FFB845"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M519.696 311.689C517.851 311.689 516.079 311.91 514.382 312.279C524.566 314.641 532.242 323.792 532.242 334.788H542.869C542.869 321.947 532.463 311.689 519.696 311.689Z",
    fill: "#D89535"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M496.596 334.788C496.596 321.947 506.928 311.689 519.696 311.689C532.463 311.689 542.795 322.021 542.795 334.788H496.596Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M550.249 334.788C550.249 325.415 557.776 317.962 567.075 317.962C576.374 317.962 583.902 325.489 583.902 334.788H550.249Z",
    fill: "#FFB845"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M550.249 334.788C550.249 325.415 557.776 317.962 567.075 317.962C576.374 317.962 583.902 325.489 583.902 334.788H550.249Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M142.208 334.788C142.208 325.489 149.736 317.962 159.035 317.962C168.334 317.962 175.861 325.489 175.861 334.788H142.208Z",
    fill: "#FFB845"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M142.208 334.788C142.208 325.489 149.736 317.962 159.035 317.962C168.334 317.962 175.861 325.489 175.861 334.788H142.208Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M227.226 334.788C227.226 328.81 232.023 324.013 238.001 324.013C243.979 324.013 248.776 328.81 248.776 334.788H227.226Z",
    fill: "#00233A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M208.333 333.829C208.333 328.884 212.319 324.899 217.263 324.899C222.208 324.899 226.193 328.884 226.193 333.829H208.333Z",
    fill: "#00233A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M227.226 334.788C227.226 328.81 232.023 324.013 238.001 324.013C243.979 324.013 248.776 328.81 248.776 334.788H227.226Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M254.458 334.788C254.458 325.489 261.986 317.962 271.285 317.962C280.584 317.962 288.111 325.489 288.111 334.788H254.458Z",
    fill: "#00233A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M397.852 334.271C397.852 327.851 403.018 322.685 409.438 322.685C415.859 322.685 421.025 327.851 421.025 334.271H397.852Z",
    fill: "#00233A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M367.594 334.271C367.594 325.858 374.457 318.995 382.87 318.995C391.284 318.995 398.147 325.858 398.147 334.271H367.594Z",
    fill: "#00233A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M254.458 334.788C254.458 325.489 261.986 317.962 271.285 317.962C280.584 317.962 288.111 325.489 288.111 334.788H254.458Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M358.443 334.788H613.569",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M327.225 334.788H345.675",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4751 334.788H316.155",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M230.252 298.257H215.492V334.788H230.252V298.257Z",
    fill: "#81440E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M230.252 298.257H215.492V334.788H230.252V298.257Z",
    fill: "#81440E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M230.252 298.257H215.492V309.475H230.252V298.257Z",
    fill: "#663717"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M382.87 298.257H368.11V334.788H382.87V298.257Z",
    fill: "#81440E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M382.87 298.257H368.11V309.475H382.87V298.257Z",
    fill: "#663717"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M230.252 298.257H215.492V334.788H230.252V298.257Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M382.87 298.257H368.11V334.788H382.87V298.257Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.344 203.35H225.012V281.652H235.344V203.35Z",
    fill: "#81440E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M235.344 219.07H225.012V269.106H235.344V219.07Z",
    fill: "#663717"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M235.344 203.35H225.012V281.652H235.344V203.35Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 203.35H363.018V281.652H373.35V203.35Z",
    fill: "#81440E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 215.232H363.018V269.106H373.35V215.232Z",
    fill: "#663717"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 203.35H363.018V281.652H373.35V203.35Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 215.306H191.286V237.446H397.926V215.306Z",
    fill: "#81440E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 215.306H191.286V222.833H397.926V215.306Z",
    fill: "#A05720"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 215.306H191.286V237.446H397.926V215.306Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 237.446H191.286V259.586H397.926V237.446Z",
    fill: "#81440E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 237.446H191.286V244.604H397.926V237.446Z",
    fill: "#A05720"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M397.926 237.446H191.286V259.586H397.926V237.446Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M423.313 283.497H175.05V298.257H423.313V283.497Z",
    fill: "#81440E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M423.313 283.497H175.05V298.257H423.313V283.497Z",
    fill: "#81440E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M423.313 283.497H175.05V289.401H423.313V283.497Z",
    fill: "#A05720"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M423.313 283.497H175.05V298.257H423.313V283.497Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M231.137 231.099C233.298 231.099 235.049 229.348 235.049 227.188C235.049 225.028 233.298 223.276 231.137 223.276C228.977 223.276 227.226 225.028 227.226 227.188C227.226 229.348 228.977 231.099 231.137 231.099Z",
    fill: "#663717"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M231.137 251.615C233.298 251.615 235.049 249.864 235.049 247.704C235.049 245.544 233.298 243.793 231.137 243.793C228.977 243.793 227.226 245.544 227.226 247.704C227.226 249.864 228.977 251.615 231.137 251.615Z",
    fill: "#663717"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M369.144 231.099C371.304 231.099 373.055 229.348 373.055 227.188C373.055 225.028 371.304 223.276 369.144 223.276C366.983 223.276 365.232 225.028 365.232 227.188C365.232 229.348 366.983 231.099 369.144 231.099Z",
    fill: "#663717"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M369.144 251.615C371.304 251.615 373.055 249.864 373.055 247.704C373.055 245.544 371.304 243.793 369.144 243.793C366.983 243.793 365.232 245.544 365.232 247.704C365.232 249.864 366.983 251.615 369.144 251.615Z",
    fill: "#663717"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M230.178 230.14C231.809 230.14 233.13 228.819 233.13 227.188C233.13 225.557 231.809 224.236 230.178 224.236C228.548 224.236 227.226 225.557 227.226 227.188C227.226 228.819 228.548 230.14 230.178 230.14Z",
    fill: "#00233A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230.178 250.656C231.809 250.656 233.13 249.335 233.13 247.704C233.13 246.074 231.809 244.752 230.178 244.752C228.548 244.752 227.226 246.074 227.226 247.704C227.226 249.335 228.548 250.656 230.178 250.656Z",
    fill: "#00233A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M368.184 230.14C369.815 230.14 371.136 228.819 371.136 227.188C371.136 225.557 369.815 224.236 368.184 224.236C366.554 224.236 365.232 225.557 365.232 227.188C365.232 228.819 366.554 230.14 368.184 230.14Z",
    fill: "#00233A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M368.184 250.656C369.815 250.656 371.136 249.335 371.136 247.704C371.136 246.074 369.815 244.752 368.184 244.752C366.554 244.752 365.232 246.074 365.232 247.704C365.232 249.335 366.554 250.656 368.184 250.656Z",
    fill: "#00233A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M409.438 356.264H413.94",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M296.451 356.264H394.9",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M262.281 356.264H279.181",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M422.058 44.0898H430.545",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M446.043 44.0898H472.98",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10303 100.252H26.564",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5933 100.252H52.025",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M662.13 93.5358H667.148",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M635.857 93.5358H650.396",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M450.619 71.1006H495.342",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M264.938 83.5728C264.864 82.9824 264.791 82.3182 264.791 81.654C264.791 75.0858 270.104 69.6984 276.746 69.6984C283.314 69.6984 288.702 75.012 288.702 81.654C288.702 88.2222 283.388 93.6096 276.746 93.6096",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M225.677 93.5358H276.746",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M612.167 60.6947C612.093 60.1043 612.02 59.4401 612.02 58.7759C612.02 52.2077 617.333 46.8203 623.975 46.8203C630.617 46.8203 635.931 52.1339 635.931 58.7759C635.931 65.4179 630.617 70.7315 623.975 70.7315",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M580.359 70.7316H623.901",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M296.155 125.27C296.082 125.86 296.008 126.524 296.008 127.189C296.008 133.757 301.321 139.144 307.963 139.144C314.605 139.144 319.919 133.831 319.919 127.189C319.919 120.547 314.605 115.233 307.963 115.233",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M262.429 115.307H307.89",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M246.045 115.307H251.433",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M206.415 115.307H232.761",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M236.377 78.7758H189.072",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5933 64.7538H56.453",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M623.385 170.435C633.085 170.435 640.949 162.572 640.949 152.871C640.949 143.171 633.085 135.307 623.385 135.307C613.684 135.307 605.82 143.171 605.82 152.871C605.82 162.572 613.684 170.435 623.385 170.435Z",
    fill: "#EF4D3C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M623.385 170.435C633.085 170.435 640.949 162.572 640.949 152.871C640.949 143.171 633.085 135.307 623.385 135.307C613.684 135.307 605.82 143.171 605.82 152.871C605.82 162.572 613.684 170.435 623.385 170.435Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0727 334.788C103.053 334.788 114.386 316.252 114.386 293.386C114.386 270.521 103.053 251.984 89.0727 251.984C75.0927 251.984 63.7593 270.521 63.7593 293.386C63.7593 316.252 75.0927 334.788 89.0727 334.788Z",
    fill: "#E97E1C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M89.0728 251.984C88.4824 251.984 87.892 252.058 87.3754 252.058C97.2646 257.667 104.349 273.091 104.349 291.098C104.349 313.017 93.9436 330.95 80.7334 332.353C83.3164 333.829 86.1946 334.64 89.0728 334.64C103.021 334.64 114.386 316.117 114.386 293.239C114.386 270.508 103.021 251.984 89.0728 251.984Z",
    fill: "#E8531F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0727 334.788C103.053 334.788 114.386 316.252 114.386 293.386C114.386 270.521 103.053 251.984 89.0727 251.984C75.0927 251.984 63.7593 270.521 63.7593 293.386C63.7593 316.252 75.0927 334.788 89.0727 334.788Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7295 334.788C91.7295 320.766 103.021 309.475 117.043 309.475C131.065 309.475 142.356 320.766 142.356 334.788H91.7295Z",
    fill: "#FF6550"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.969 309.475C114.755 309.475 112.688 309.77 110.622 310.286C121.544 313.091 129.589 322.98 129.589 334.788H142.282C142.282 320.766 130.917 309.475 116.969 309.475Z",
    fill: "#FF7364"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7295 334.788C91.7295 320.766 103.021 309.475 117.043 309.475C131.065 309.475 142.356 320.766 142.356 334.788H91.7295Z",
    stroke: "#00233A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M552.906 86.7462C556.126 86.7462 558.736 84.1359 558.736 80.916C558.736 77.6961 556.126 75.0858 552.906 75.0858C549.686 75.0858 547.075 77.6961 547.075 80.916C547.075 84.1359 549.686 86.7462 552.906 86.7462Z",
    fill: "#FF6550"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M540.729 115.307C544.886 115.307 548.256 111.936 548.256 107.779C548.256 103.622 544.886 100.252 540.729 100.252C536.572 100.252 533.201 103.622 533.201 107.779C533.201 111.936 536.572 115.307 540.729 115.307Z",
    fill: "#FF6550"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M580.359 175.528C584.516 175.528 587.887 172.157 587.887 168C587.887 163.843 584.516 160.472 580.359 160.472C576.202 160.472 572.832 163.843 572.832 168C572.832 172.157 576.202 175.528 580.359 175.528Z",
    fill: "#FF6550"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M583.902 134.716C588.059 134.716 591.429 131.346 591.429 127.189C591.429 123.031 588.059 119.661 583.902 119.661C579.744 119.661 576.374 123.031 576.374 127.189C576.374 131.346 579.744 134.716 583.902 134.716Z",
    fill: "#FF7364"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M86.8588 289.622C90.2418 289.622 92.9842 286.88 92.9842 283.497C92.9842 280.114 90.2418 277.372 86.8588 277.372C83.4758 277.372 80.7334 280.114 80.7334 283.497C80.7334 286.88 83.4758 289.622 86.8588 289.622Z",
    fill: "#FFB845"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.9287 297.667C79.9257 297.667 81.5449 296.048 81.5449 294.05C81.5449 292.053 79.9257 290.434 77.9287 290.434C75.9317 290.434 74.3125 292.053 74.3125 294.05C74.3125 296.048 75.9317 297.667 77.9287 297.667Z",
    fill: "#E8531F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M92.984 308.146C95.3478 308.146 97.2644 306.23 97.2644 303.866C97.2644 301.502 95.3478 299.585 92.984 299.585C90.6202 299.585 88.7036 301.502 88.7036 303.866C88.7036 306.23 90.6202 308.146 92.984 308.146Z",
    fill: "#FFB845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPlaceholder);
export default __webpack_public_path__ + "static/media/dashboardPlaceholder.15d4b73f3bf8984f7edaedac4ebe13c5.svg";
export { ForwardRef as ReactComponent };